export const qualificationActionList =[
  {
    path: '/qualification',
  }
]

export const codeTypeEnum = {
  headPic: 2,// 门头图
  idCard: 0,// 身份证
  businessLicense: 1,// 营业执照
  leaseContract: 6,// 租赁合同
  propertyCertificate: 14,// 房产证
}

// 身份证类型-正面/反面
export const idCardType = {
  front: 'front',
  back: 'back',
}

const headPic = {
  codeType: codeTypeEnum.headPic,
  label: '门头照',
  exampleUrl: 'https://p1.meituan.net/dpgroup/6fde903c5b16eb71e71c564973a892eb370610.png',
  // 表单渲染配置项
  formConfig: {
    rules: [
      {
        required: true,
        message: '请上传门头照',
      },
    ],
  }
};
const idCard1 = {
  codeType: codeTypeEnum.idCard,
  subType: idCardType.front,
  label: '身份证正面',
  exampleUrl: 'https://p1.meituan.net/dpgroup/3ea89f93a742374388e255d98c477aca243591.jpg',
  formConfig: {},
}
const idCard2 = {
  codeType: codeTypeEnum.idCard,
  subType: idCardType.back,
  label: '身份证反面',
  exampleUrl: 'https://p1.meituan.net/dpgroup/16c7f9d18acca8e18cb133c9db8ae60745660.jpg',
  formConfig: {},
}
const businessLicense = {
  codeType: codeTypeEnum.businessLicense,
  label: '营业执照',
  exampleUrl: 'https://p0.meituan.net/dpgroup/70f5265020446dd90aa6a1a63f5bc603990241.jpg',
  formConfig: {},
}
const leaseContract = {
  codeType: codeTypeEnum.leaseContract,
  label: '租赁合同',
  exampleUrl: 'https://p1.meituan.net/travelcube/5e5a9ec67a0390d50b46bb78264591e7989643.png',
  formConfig: {},
}
const propertyCertificate = {
  codeType: codeTypeEnum.propertyCertificate,
  label: '房产证',
  exampleUrl: 'https://p1.meituan.net/travelcube/c0b07011ef7dbf309f5296093ba7f395296116.png',
  formConfig: {},
}

// 各组件渲染的顺序列表
export const moduleList = [headPic, idCard1, idCard2, businessLicense, leaseContract, propertyCertificate];
